module.exports = __webpack_public_path__ + "static/media/food.6adc8581.png";